import useCurrencyStore from "store/currencyStore";
import { priceInCurrency } from "utils";

export default function usePrice({ isFree, usdPrice = 0, zwlPrice = 0, sellable, prices }) {
    const { currency } = useCurrencyStore();
    if (isFree || !sellable) return 0;
    return priceInCurrency(prices, currency, usdPrice, zwlPrice);
}
